import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Button, Layer, TextInput, Box, Anchor, RadioButtonGroup, Text, SelectMultiple } from 'grommet';
import { FormClose } from 'grommet-icons';

import { TitleField, DescriptionField, SelectSearch } from '../../../../components/form';
import { TitleDetail, Hr } from '../../../../components/detail';

import { getCity } from '../../../../actions/select-options';
import { searchAmendments, clearFieldsFormSearch, hideLayer, setDefaultPageRules } from '../../actions/form-search';
import { changeValues } from '../../../../actions/form';

import paginationDefault from '../../../../constants/pagination';
import visibleWidth from '../../../../constants/layer-width';

import selectAmendmentResourceOriginOptions from '../../../../constants/select-amendment-resource-origin-options';

import TYPES from '../../actions/types';

class FormSearch extends Component {
  searchAndSetPagination = formParams => {
    const { searchAmendments, hideLayer, setDefaultPageRules } = this.props;

    setDefaultPageRules();
    searchAmendments(formParams);
    hideLayer();
  };

  onSearchCities = text => {
    if (text.length < 3) return;

    const { getCity } = this.props;
    getCity({ name: text });
  };

  render() {
    const {
      userLogged,

      departmentOptions,
      stageAmendmentsOptions,
      cityOptions,

      reference,
      object,
      beneficiary,
      valueInit,
      valueEnd,
      requester,
      region,
      stageId,
      secretaryId,
      resourceOrigin,
      year,

      toggleLayer,
      hideLayer,
      clearFieldsFormSearch,
      changeValues,
    } = this.props;

    if(!toggleLayer || toggleLayer !== 'search') {
      return null;
    }

    return (
      <ResponsiveContext.Consumer>
        {size => (
          <Layer
            responsive={false}
            full='vertical'
            position='left'
            onClickOutside={hideLayer}
            onEsc={hideLayer}
          >
            <Box
              fill='vertical'
              width={visibleWidth[size]}
              pad={{ top: 'large', bottom: 'xsmall' }}
              overflow='auto'
              flex
            >
              <Box
                direction='row'
                justify='between'
                align='baseline'
                margin={{ horizontal: 'large' }}
              >
                <TitleDetail value='Filtrar' />

                <Button
                  plain
                  title='Fechar'
                  icon={<FormClose />}
                  onClick={hideLayer}
                />
              </Box>


              <Box flex overflow='auto'>
                {/* Estágio */}
                <Box
                  margin={{
                    vertical: size === 'small' ? 'medium' : 'small',
                    horizontal: 'large'
                  }}
                  flex={{ shrink: 0 }}
                >
                  <Box direction='row' align='center' gap='xsmall'>
                    <TitleField text='Estágio' />

                    {stageId && (<Anchor
                      size='small'
                      label='limpar'
                      onClick={() =>
                        changeValues(
                          {fieldName: 'stageId', value: null }, TYPES.changeFormSearchField
                        )
                      }
                    />)}
                  </Box>

                  <SelectSearch
                    options={stageAmendmentsOptions}
                    labelKey='name'
                    valueKey={{ key: 'id', reduce: true }}
                    value={stageId ?? ''}
                    emptySearchMessage='Selecione uma opção'
                    placeholder='Selecione um estágio para filtrar'
                    onChange={({ value: nextValue }) =>
                      changeValues(
                        {fieldName: 'stageId', value: nextValue }, TYPES.changeFormSearchField
                      )
                    }
                  />
                </Box>


                {/* Objeto */}
                <Box
                  margin={{
                    vertical: 'small',
                    horizontal: 'large'
                  }}
                  direction={ size === 'small' ? 'column' : 'row' }
                  align='stretch'
                  flex={{ shrink: 0 }}
                  gap='small'

                >
                  <Box
                    width={ size === 'small' ? '100vw' : '50vw' }
                    gap='xxsmall'
                  >
                    <TitleField text='Objeto' />

                    <DescriptionField
                      text='Busque por um trecho do texto.'
                    />
                  </Box>

                  <Box
                    width={ size === 'small' ? '100vw' : '50vw'}
                  >
                    <TextInput
                      value={object ?? ''}
                      placeholder='Ex. Infraestrutura ou infra ou estrutura'
                      onChange={event =>
                        changeValues(
                          {fieldName: 'object', value: event.target.value }, TYPES.changeFormSearchField
                        )
                      }
                    />
                  </Box>
                </Box>


                {/* Beneficiário */}
                <Box
                  margin={{
                    vertical: 'small',
                    horizontal: 'large'
                  }}
                  direction={ size === 'small' ? 'column' : 'row' }
                  align='stretch'
                  flex={{ shrink: 0 }}
                  gap='small'

                >
                  <Box
                    width={ size === 'small' ? '100vw' : '50vw' }
                    gap='xxsmall'
                  >
                    <TitleField text='Beneficiário' />

                    <DescriptionField
                      text='Busque por um trecho do nome que foi cadastrado.'
                    />
                  </Box>

                  <Box
                    width={ size === 'small' ? '100vw' : '50vw'}
                  >
                    <TextInput
                      value={beneficiary ?? ''}
                      placeholder='Ex. Pref ou Prefeitura'
                      onChange={event =>
                        changeValues(
                          {fieldName: 'beneficiary', value: event.target.value }, TYPES.changeFormSearchField
                        )
                      }
                    />
                  </Box>
                </Box>


                {/* Solicitante */}
                <Box
                  margin={{
                    vertical: 'small',
                    horizontal: 'large'
                  }}
                  direction={ size === 'small' ? 'column' : 'row' }
                  align='stretch'
                  flex={{ shrink: 0 }}
                  gap='small'

                >
                  <Box
                    width={ size === 'small' ? '100vw' : '50vw' }
                    gap='xxsmall'
                  >
                    <TitleField text='Solicitante' />

                    <DescriptionField
                      text='Busque por um trecho do nome da pessoa.'
                    />
                  </Box>

                  <Box
                    width={ size === 'small' ? '100vw' : '50vw'}
                  >
                    <TextInput
                      value={requester ?? ''}
                      onChange={event =>
                        changeValues(
                          {fieldName: 'requester', value: event.target.value }, TYPES.changeFormSearchField
                        )
                      }
                    />
                  </Box>
                </Box>

                <Hr />


                {/* Secretaria */}
                <Box
                  margin={{
                    vertical: size === 'small' ? 'medium' : 'small',
                    horizontal: 'large'
                  }}
                  flex={{ shrink: 0 }}
                >
                  <Box direction='row' align='center' gap='xsmall'>
                    <TitleField text='Secretaria' />

                    {secretaryId && (<Anchor
                      size='small'
                      label='limpar'
                      onClick={() =>
                        changeValues(
                          {fieldName: 'secretaryId', value: null }, TYPES.changeFormSearchField
                        )
                      }
                    />)}
                  </Box>

                  <SelectSearch
                    options={departmentOptions}
                    labelKey='name'
                    valueKey={{ key: 'id', reduce: true }}
                    value={secretaryId ?? ''}
                    emptySearchMessage='Selecione uma opção'
                    placeholder='Selecione uma secretaria para filtrar'
                    onChange={({ value: nextValue }) =>
                      changeValues(
                        {fieldName: 'secretaryId', value: nextValue }, TYPES.changeFormSearchField
                      )
                    }
                  />
                </Box>


                {/* Origem recurso */}
                <Box
                  margin={{
                    vertical: size === 'small' ? 'medium' : 'small',
                    horizontal: 'large'
                  }}
                  flex={{ shrink: 0 }}
                >
                  <Box direction='row' align='center' gap='xsmall'>
                    <TitleField text='Origem do recurso' />

                    {resourceOrigin && (<Anchor
                      size='small'
                      label='limpar'
                      onClick={() =>
                        changeValues({ fieldName: 'resourceOrigin', value: null }, TYPES.changeFormSearchField)
                      }
                    />)}
                  </Box>

                  <Box
                    round='xxsmall'
                    pad={{
                      vertical: 'small',
                    }}
                    gap='xsmall'
                  >
                    <RadioButtonGroup
                      name='resourceOrigin'
                      value={resourceOrigin ?? ''}
                      options={
                        selectAmendmentResourceOriginOptions
                          .filter(option =>
                            option.productSystems.includes(userLogged.client?.productId)
                          )
                          .map(({ name, id }) => ({
                              label: name,
                              id: `resourceOrigin_${id}`,
                              value: id.toString(),
                            })
                          )
                      }
                      onChange={event => {
                        changeValues({ fieldName: 'resourceOrigin', value: event.target.value }, TYPES.changeFormSearchField)
                      }}
                    >
                      {(option, { checked }) => {
                        let background = null;
                        let borderColor = 'dark-5';

                        if(checked) {
                          background = 'brand';
                          borderColor = 'brand';
                        }

                        return (
                          <Box
                            direction='row'
                            gap='small'
                            justify='center'
                            align='center'
                          >
                            <Box
                              width={'20px'}
                              height={'20px'}
                              background={background}
                              round='xxsmall'
                              border={{
                                color: borderColor
                              }}
                            />
                            <Text color='dark-2' size='small'>{option.label}</Text>
                          </Box>
                        )
                      }}
                    </RadioButtonGroup>
                  </Box>
                </Box>


                {/* Cidade */}
                <Box
                  margin={{
                    vertical: 'small',
                    horizontal: 'large'
                  }}
                  direction={ size === 'small' ? 'column' : 'row' }
                  align='stretch'
                  flex={{ shrink: 0 }}
                  gap='small'
                >
                  <Box
                    width={ size === 'small' ? '100vw' : '50vw' }
                    gap='xxsmall'
                  >
                    <TitleField
                      text='Cidade'
                    />

                    <DescriptionField
                      text='Busque por uma ou mais cidades...'
                    />
                  </Box>

                  <Box
                    width={ size === 'small' ? '100vw' : '50vw' }
                  >
                    <SelectMultiple
                      searchPlaceholder='Digite para buscar...'
                      emptySearchMessage=''
                      options={cityOptions}
                      value={region ?? ''}
                      labelKey='name'
                      valueKey={{ key: 'id', reduce: true }}
                      dropHeight='medium'
                      placeholder='Selecione a cidade'
                      sortSelectedOnClose
                      messages={{
                        clearAll: 'Limpar',
                        selectAll: 'Selecionar todos',
                        selected: '{selected} selecionado(s)',
                        selectedOfTotal: '{selected} de {total} selecionado(s)',
                      }}
                      onSearch={ text => this.onSearchCities(text) }
                      onChange={({ value: nextValue }) =>
                        changeValues(
                          {fieldName: 'region', value: nextValue }, TYPES.changeFormSearchField
                        )
                      }
                      valueLabel={
                        region && region.length > 1 ? (
                          <Box pad='small'>
                            <Text>{`${region.length} selecionado(s)`}</Text>
                          </Box>
                        ) : null
                      }
                    >
                      {(option, index, options, { active, disabled, selected }) => {
                        return (
                          <Box
                            pad={{ horizontal: 'small', vertical: 'small' }}
                            gap='small'
                            direction='row'
                            align='baseline'
                          >
                            <Text
                              size='medium'
                              color='dark-1'
                              weight={selected ? 'bold' : 'normal'}
                            >
                              {option.name}
                            </Text>

                            <Text size='small' color='dark-6' weight={selected ? 'bold' : 'normal'}>
                              {option.stateAbbrev}
                            </Text>
                          </Box>
                        )
                      }}
                    </SelectMultiple>
                  </Box>
                </Box>


                {/* Ano */}
                <Box
                  margin={{
                    vertical: 'small',
                    horizontal: 'large'
                  }}
                  direction={ size === 'small' ? 'column' : 'row' }
                  align='stretch'
                  flex={{ shrink: 0 }}
                  gap='small'

                >
                  <Box
                    width={ size === 'small' ? '100vw' : '50vw' }
                    gap='xxsmall'
                  >
                    <TitleField text='Ano da emenda' />

                    <DescriptionField
                      text='Busque digitando o ano com quatro digitos.'
                    />
                  </Box>

                  <Box
                    width={ size === 'small' ? '100vw' : '50vw' }
                  >
                    <TextInput
                      type='number'
                      min={0}
                      value={year ?? ''}
                      placeholder='Ex. 2024'
                      onChange={event =>
                        changeValues(
                          {fieldName: 'year', value: event.target.value }, TYPES.changeFormSearchField
                        )
                      }
                    />
                  </Box>
                </Box>
              </Box>

              <Box
                direction='row'
                pad={{ vertical: 'medium' }}
                margin={{ horizontal: 'large' }}
                justify='center'
                align='center'
                gap='small'
              >
                <Box width='small'>
                  <Button
                    color='dark-3'
                    label='Limpar'
                    onClick={() => clearFieldsFormSearch()}
                  />
                </Box>

                <Box width='small'>
                  <Button
                    color='brand'
                    primary
                    label='Buscar'
                    onClick={() =>
                      this.searchAndSetPagination({
                        reference,
                        object,
                        beneficiary,
                        valueInit,
                        valueEnd,
                        requester,
                        region,
                        stageId,
                        secretaryId,
                        resourceOrigin,
                        year,
                        page: paginationDefault.page,
                        limit: paginationDefault.limit,
                      })
                    }
                  />
                </Box>
              </Box>
            </Box>
          </Layer>
        )}
      </ResponsiveContext.Consumer>
    );
  }
}

const mapStateToProps = ({
  authReducer: { authenticated }, amendmentReducer: { formSearch }, layerReducer, selectOptionsReducer
}) => ({
  userLogged: authenticated,

  departmentOptions: selectOptionsReducer.departmentOptions,
  stageAmendmentsOptions: selectOptionsReducer.stageAmendmentsOptions,
  cityOptions: selectOptionsReducer.cityOptions,

  reference: formSearch.reference,
  object: formSearch.object,
  beneficiary: formSearch.beneficiary,
  valueInit: formSearch.valueInit,
  valueEnd: formSearch.valueEnd,
  requester: formSearch.requester,
  region: formSearch.region,
  stageId: formSearch.stageId,
  secretaryId: formSearch.secretaryId,
  resourceOrigin: formSearch.resourceOrigin,
  year: formSearch.year,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    searchAmendments,
    clearFieldsFormSearch,
    setDefaultPageRules,
    hideLayer,
    changeValues,
    getCity,
  }, dispatch);

export const Search = connect(mapStateToProps, mapDispatchToProps)(FormSearch);
